import { render } from "./Climbing.vue?vue&type=template&id=759ed7a6&scoped=true&lang=pug"
import script from "./Climbing.vue?vue&type=script&lang=js"
export * from "./Climbing.vue?vue&type=script&lang=js"

import "./Climbing.vue?vue&type=style&index=0&id=759ed7a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759ed7a6"]])

export default __exports__